<!-- Sidebar Header starts -->
<div class="sa-sidebar-v2">
<div class="sidebar-header" *ngIf="config?.layout.menuPosition === 'Side'">
  <!-- Intentionally minimal header (brand removed per v2 sidebar design) -->
  <div class="logo clearfix header mx-2 py-2 px-0 sa-header-flat"></div>
    <!-- <a class="nav-toggle d-none d-lg-none d-xl-block" id="sidebarToggle" href="javascript:;" (click)="toggleSidebar()">
      <i #toggleIcon [ngClass]="{
        'ft-toggle-left': config.layout.sidebar.collapsed,
        'ft-toggle-right': !config.layout.sidebar.collapsed
      }" class="toggle-icon"></i>
    </a> -->
    <!-- <a class="nav-close d-block d-lg-block d-xl-none" id="sidebarClose" href="javascript:;" (click)="CloseSidebar()">
      <i class="ft-x"></i>
    </a> -->
</div>
<!-- Sidebar Header Ends -->

<!-- Sidebar Content starts -->
<div class="sidebar-content main-menu-content " [perfectScrollbar] [disabled]="!perfectScrollbarEnable">
  <div class="nav-container ">
    <!-- Profile block -->
    <div class="sa-sticky-top">
      <div class="sa-profile-card">
        <div class="sa-logo-box">
          <img src="assets/img/auth/reeworklogo.png" alt="Reework Logo" class="sa-sidebar-logo">
        </div>
        <button
          type="button"
          class="sa-profile-toggle"
          [title]="config?.layout?.sidebar?.collapsed ? 'Expand sidebar' : 'Collapse sidebar'"
          [attr.aria-label]="config?.layout?.sidebar?.collapsed ? 'Expand sidebar' : 'Collapse sidebar'"
          (click)="$event.stopPropagation(); toggleSidebar()"
        >
          <i
            [ngClass]="{
              'ft-chevrons-right': config?.layout?.sidebar?.collapsed,
              'ft-chevrons-left': !config?.layout?.sidebar?.collapsed
            }"
            aria-hidden="true"
          ></i>
        </button>
      </div>
    </div>

    <ul class="navigation sa-nav" appSidebarDropdown>
      <!-- Shimmer loading skeleton -->
      <ng-container *ngIf="isMenuLoading">
        <li class="sa-section">
          <div class="sa-section-label shimmer-text" style="width: 50px;">&nbsp;</div>
        </li>
        <li class="shimmer-item" *ngFor="let i of [1,2,3,4,5,6,7]">
          <a class="d-flex align-items-center shimmer-link">
            <span class="sa-icon shimmer-icon"></span>
            <span class="shimmer-title" [style.width.%]="60 + (i * 5)"></span>
          </a>
        </li>
      </ng-container>

      <!-- First level menu + section headers -->
      <ng-container *ngIf="!isMenuLoading">
      <ng-container *ngFor="let menuItem of renderItems">
        <li *ngIf="menuItem.__type === 'header'" class="sa-section">
          <div class="sa-section-label">{{ menuItem.label }}</div>
        </li>

        <li
          *ngIf="menuItem.__type !== 'header'"
          appSidebarlink
          [parent]="menuItem.title"
          [path]="menuItem.path"
          level="{{level + 1}}"
          [hasSub]="menuItem.class.includes('has-sub') ? true: false"
          [ngClass]="{'has-sub': menuItem.class.includes('has-sub') ? true: false}"
          [routerLinkActive]="menuItem.submenu.length != 0 ? 'open' : 'active'"
          [routerLinkActiveOptions]="{exact: false}"
        >
        <a class="d-flex align-items-center" appSidebarAnchorToggle
          *ngIf="menuItem.submenu.length > 0 && !menuItem.isExternalLink">
          <span class="sa-icon">
            <i [ngClass]="menuFeatherIcon(menuItem)" class="sa-feather" aria-hidden="true"></i>
          </span>
          <span class="menu-title">{{menuItem.title }}</span>
          <span *ngIf="menuItem.badge && menuItem.badge != '' "
            [ngClass]="[menuItem.badgeClass]">{{menuItem.badge}}</span>
        </a>
        <a class="d-flex align-items-center" appSidebarAnchorToggle routerLink="{{menuItem.path}}"
          (click)="onMenuClick(menuItem)"
          *ngIf="menuItem.submenu.length === 0 && !menuItem.isExternalLink">
          <span class="sa-icon">
            <i [ngClass]="menuFeatherIcon(menuItem)" class="sa-feather" aria-hidden="true"></i>
          </span>
          <span class="menu-title">{{menuItem.title }}</span>
          <span *ngIf="menuItem.badge && menuItem.badge != '' "
            [ngClass]="[menuItem.badgeClass]">{{menuItem.badge}}</span>
        </a>
        <a class="d-flex align-items-center" [href]="[menuItem.path]" target="_blank" *ngIf="menuItem.isExternalLink">
          <span class="sa-icon">
            <i [ngClass]="menuFeatherIcon(menuItem)" class="sa-feather" aria-hidden="true"></i>
          </span>
          <span class="menu-title">{{menuItem.title }}</span>
          <span *ngIf="menuItem.badge && menuItem.badge != '' "
            [ngClass]="[menuItem.badgeClass]">{{menuItem.badge}}</span>
        </a>
        <!-- Second level menu -->
        <ul appSidebarDropdown class="menu-content" *ngIf="menuItem.submenu.length > 0 ">
          <li appSidebarlink *ngFor="let menuSubItem of menuItem.submenu" [parent]="menuItem.title"
            [hasSub]="menuSubItem.class.includes('has-sub') ? true: false" [path]="menuSubItem.path"
            level="{{level + 2}}" [ngClass]="{'has-sub': menuSubItem.class.includes('has-sub') ? true: false}"
            [routerLinkActive]="menuSubItem.submenu.length != 0 ? 'open' : 'active'">
            <a appSidebarAnchorToggle *ngIf="menuSubItem.submenu.length > 0 && !menuSubItem.isExternalLink">
              <i [ngClass]="[menuSubItem.icon]"></i>
              <span class="menu-title">{{menuSubItem.title }}</span>
              <span *ngIf="menuSubItem.badge && menuSubItem.badge != '' "
                [ngClass]="[menuSubItem.badgeClass]">{{menuSubItem.badge}}</span>
            </a>
            <a appSidebarAnchorToggle routerLink="{{menuSubItem.path}}"
              (click)="onMenuClick(menuSubItem)"
              *ngIf="menuSubItem.submenu.length === 0 && !menuSubItem.isExternalLink">
              <i [ngClass]="[menuSubItem.icon]"></i>
              <span class="menu-title">{{menuSubItem.title }}</span>
              <span *ngIf="menuSubItem.badge && menuSubItem.badge != '' "
                [ngClass]="[menuSubItem.badgeClass]">{{menuSubItem.badge}}</span>
            </a>
            <a routerLink="{{menuSubItem.path}}" target="_blank" *ngIf="menuSubItem.isExternalLink">
              <i [ngClass]="[menuSubItem.icon]"></i>
              <span class="menu-title">{{menuSubItem.title }}</span>
              <span *ngIf="menuSubItem.badge && menuSubItem.badge != '' "
                [ngClass]="[menuSubItem.badgeClass]">{{menuSubItem.badge}}</span>
            </a>
            <!-- Third level menu -->
            <ul appSidebarDropdown class="menu-content" *ngIf="menuSubItem.submenu.length > 0">
              <li appSidebarlink *ngFor="let menuSubsubItem of menuSubItem.submenu" [parent]="menuItem.title"
                [hasSub]="false" [path]="menuSubsubItem.path" level="{{level + 3}}" routerLinkActive="active"
                [routerLinkActiveOptions]="{exact: true}"
                [ngClass]="config.layout.menuPosition === 'Side' ? menuSubsubItem.class : ''">
                <a appSidebarAnchorToggle routerLink="{{menuSubsubItem.path}}"
                  (click)="onMenuClick(menuSubsubItem)"
                  *ngIf="!menuSubsubItem.isExternalLink; else externalSubSubLinkBlock">
                  <i [ngClass]="[menuSubsubItem.icon]"></i>
                  <span class="menu-title">{{menuSubsubItem.title }}</span>
                  <span *ngIf="menuSubsubItem.badge && menuSubsubItem.badge != '' "
                    [ngClass]="[menuSubsubItem.badgeClass]">{{menuSubsubItem.badge}}</span>
                </a>
                <ng-template #externalSubSubLinkBlock>
                  <a routerLink="{{menuSubsubItem.path}}" target="_blank">
                    <i [ngClass]="[menuSubsubItem.icon]"></i>
                    <span class="menu-title">{{menuSubsubItem.title }}</span>
                    <span *ngIf="menuSubsubItem.badge && menuSubsubItem.badge != '' "
                      [ngClass]="[menuSubsubItem.badgeClass]">{{menuSubsubItem.badge}}</span>
                  </a>
                </ng-template>
              </li>
            </ul>
          </li>
        </ul>
      </li></ng-container>
      </ng-container>
    </ul>
  </div>
</div>
<!-- Sidebar Content Ends -->
</div>
